declare const ENV: Record<string, string | undefined>

const readString = (value: unknown) => (typeof value === 'string' ? value : '')

export const crmEnv = {
  apiBaseUrl: readString(ENV.CRM_API_BASE_URL || ENV.VITE_API_BASE_URL || ENV.API_BASE_URL) || '/',
}
